import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import {
  BannerIconWrapper,
  StyledA,
  StyledCard,
  StyledSpanElement,
} from "../../Styles/GlobalStyles";
import { Theme } from "../../Styles/GlobalTheme";

declare global {
  interface Window {
    triggerOmniChat: any;
    minimizeChat: any;
  }
}

function ImportantUpdatesBanner({ content }: any) {
  const message = content?.paymentMessage ?? "";
  const [firstPart, middlePart, lastPart] = message.split(/("Chat")/);
  const hasBoldTagInPaymentMessage = /<b>.*?<\/b>/i.test(message);

  const renderTextWithBoldTags = (text: string, keyPrefix: string): ReactNode => {
    const boldRegex = /<b>(.*?)<\/b>/gi;
    const nodes: ReactNode[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = boldRegex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        nodes.push(
          <span key={`${keyPrefix}-text-${lastIndex}`}>{text.slice(lastIndex, match.index)}</span>
        );
      }

      nodes.push(
        <span key={`${keyPrefix}-bold-${match.index}`} style={{ fontWeight: 700 }}>
          {match[1]}
        </span>
      );

      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length) {
      nodes.push(<span key={`${keyPrefix}-text-end`}>{text.slice(lastIndex)}</span>);
    }

    return <>{nodes}</>;
  };

  const autoPaySubDescription = content?.autoPaySubDiscription ?? "";
  const match = autoPaySubDescription.match(/\[(.*?)\]/);
  const extractedText = match ? match[1] : "";
  const parts = autoPaySubDescription.split(/\[.*?\]/);

  return (
    <StyledCard
      sx={{
        padding: "16px",
        boxShadow: `0px 0px 8px 0px ${Theme.palette.customcolor.bannerShadow}`,
        backgroundColor: Theme.palette.customcolor.importantUpdatesBannerBg,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}>
      <Stack spacing={1} alignItems="center" direction="row" flexGrow={1}>
        {content?.icon && (
          <BannerIconWrapper bgColor={Theme.palette.customcolor.homepageiconbg}>
            {content.icon}
          </BannerIconWrapper>
        )}
        <Stack gap={{ xs: 1, md: 0 }}>
          <Typography fontWeight={600} fontSize={{ xs: "14px", sm: "18px" }}>
            {content.title}
          </Typography>
          <Stack direction="row" alignItems="center" flexWrap="wrap">
            {content?.message && (
              <Typography fontSize={{ xs: "12px", sm: "14px" }}>{content?.message}</Typography>
            )}
            {content?.paymentMessage && (
              <Typography fontSize={{ xs: "12px", sm: "14px" }}>
                {hasBoldTagInPaymentMessage ? (
                  renderTextWithBoldTags(message, "payment-message")
                ) : (
                  <>
                    {firstPart}
                    <StyledSpanElement
                      style={{ fontWeight: "bold" }}
                      onClick={() =>
                        window.triggerOmniChat && window.triggerOmniChat("D582223DCFE61")
                      }>
                      {middlePart}
                    </StyledSpanElement>
                    {lastPart}
                  </>
                )}
              </Typography>
            )}

            {content?.autoPay && (
              <Typography sx={{ mr: "4px" }}>{content.chatSupportText}</Typography>
            )}

            {content?.subHeading && (
              <Typography
                fontSize={"12px"}
                color={Theme.palette.customcolor.profileTypoGraphyColor}>
                {content?.subHeading}&nbsp;
              </Typography>
            )}

            {content?.description && (
              <Typography
                sx={{ fontSize: { xs: "12px", sm: "14px" } }}
                color={Theme.palette.customcolor.profileTypoGraphyColor}>
                {content?.description}&nbsp;
              </Typography>
            )}

            {content?.autopayDescription && content?.autoPaySubDiscription && (
              <>
                <Typography
                  sx={{ fontSize: { xs: "12px", sm: "14px" } }}
                  color={Theme.palette.customcolor.profileTypoGraphyColor}>
                  {content?.autopayDescription}&nbsp;
                </Typography>
                <Typography
                  sx={{ fontSize: { xs: "12px", sm: "14px" } }}
                  color={Theme.palette.customcolor.profileTypoGraphyColor}>
                  {parts[0]}
                  {extractedText && (
                    <StyledSpanElement
                      style={{ fontWeight: "bold" }}
                      onClick={() =>
                        window.triggerOmniChat && window.triggerOmniChat("D582223DCFE61")
                      }>
                      {extractedText?.toUpperCase()}
                    </StyledSpanElement>
                  )}
                  {parts[1]}
                </Typography>
              </>
            )}

            {content.linkText && content.link && (
              <StyledA
                sx={{
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: { xs: "12px", sm: "14px" },
                }}
                target="_blank"
                href={content.link}>
                {content.linkText}
              </StyledA>
            )}

            {!content?.autoPay && <Typography>{content.chatSupportText}</Typography>}
          </Stack>
        </Stack>
      </Stack>
    </StyledCard>
  );
}

export default ImportantUpdatesBanner;
